import React, { useCallback } from 'react'
import { googleAnalyticsEvent } from 'shared/util/analytics'
import { getSearchPath } from 'shared/util/search'
// @ts-ignore
import css from './tag.css'

type Props = {
    name: string
    analytics: {
        category: string
        action: string
    }
    onHover?: Function
    onClick?: Function
    isSticker: boolean
}
const Tag = ({ name, analytics, onHover, onClick, isSticker }: Props) => {
    const handleClick = useCallback(() => {
        const { action, category } = analytics
        googleAnalyticsEvent({
            category,
            action,
            label: name,
        })
        onClick?.()
    }, [onClick, name, analytics])

    const handleHover = useCallback(() => {
        onHover?.()
    }, [])

    const hasWordSticker = name.indexOf('sticker') === -1
    return (
        <a
            className={css.pill}
            href={isSticker && hasWordSticker ? getSearchPath(name, true) : getSearchPath(name)}
            onClick={handleClick}
            onMouseEnter={handleHover}
        >
            <h3 className={css.tag}>{`#${name}`}</h3>
        </a>
    )
}

export default Tag
